<template>
  <v-card
    max-width="550"
    :loading="admin.productImagesLoading"
    :disabled="admin.productImagesLoading"
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card width="450" color="white" light elevation="5">
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text>
          <v-img
            max-height="125"
            :src="imageToDelete ? imageToDelete.url : ''"
            contain
          ></v-img>
        </v-card-text>
        <v-card-text class="text-h5 pt-12"> Delete Image? </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteImage">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-text>
      <v-container>
        <v-row>
          <draggable tag="v-layout" class="row wrap" v-model="productImageList">
            <div
              v-for="(image, index) in productImageList"
              :key="image.id"
              class="mx-4 my-4"
            >
              <v-flex>
                <v-card
                  width="125"
                  color="white"
                  light
                  height="200"
                  :class="getClasses(index)"
                  elevation="5"
                >
                  <v-chip
                    v-if="index == 0"
                    class="position-absolute top-5 start-5"
                    color="primary"
                    dark
                    small
                  >
                    <v-icon small color="yellow darken-2" left
                      >mdi-asterisk-circle-outline</v-icon
                    >
                    PRIMARY
                  </v-chip>
                  <v-btn
                    absolute
                    bottom
                    right
                    class="deleteButton"
                    icon
                    color="error"
                    @click="confirmDeleteImage(image)"
                    ><v-icon>mdi-trash-can</v-icon></v-btn
                  >
                  <v-avatar color="grey" size="30" class="positionAvatar">
                    <span class="white--text text-h6">{{ index + 1 }}</span>
                  </v-avatar>
                  <v-card-text>
                    <v-img :src="image.url" contain max-height="100"></v-img>
                  </v-card-text>
                </v-card>
              </v-flex>
            </div>
          </draggable>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-text>
      <v-row>
        <drop-file saveAction="admin/saveProductImages" />
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import DropFile from '../../file/DropFile.vue';

  export default {
    components: {
      DropFile,
      draggable: () => import('vuedraggable')
    },
    data() {
      return {
        showConfirmationDialog: false,
        imageToDelete: null
      };
    },
    methods: {
      getClasses(index) {
        return index == 0 ? 'zoom' : '';
      },
      /**
       * Confirms if an image should be deleted
       */
      confirmDeleteImage(image) {
        this.imageToDelete = image;
        this.showConfirmationDialog = true;
      },
      /**
       * Deletes selected image
       */
      deleteImage() {
        //console.log('deleting image ' + this.imageToDelete.id)
        this.$store.dispatch('admin/deleteProductImage', this.imageToDelete.id);
        this.showConfirmationDialog = false;
      }
    },
    mounted() {},
    computed: {
      ...mapState(['app', 'admin']),
      productImageList: {
        get() {
          return this.admin.productImageList;
        },
        set(val) {
          console.log(val);
          // update displayOrder to match the new order
          for (let i = 0; i < val.length; i++) {
            val[i].displayOrder = i + 1;
          }
          this.$store.commit('admin/setProductImageList', val);
          this.$store.dispatch('admin/saveImageOrder');
        }
      }
    }
  };
</script>

<style scoped>
  .orderInput {
    max-width: 40px;
  }
  .positionAvatar {
    position: absolute;
    bottom: 5px;
    left: 5px;
    z-index: 1;
  }
  .deleteButton {
    right: 5px !important;
    bottom: 5px !important;
    z-index: 1;
  }
  .zoom {
    transform: scale(1.05);
    border: 4px solid #2196f3 !important;
    border-color: #2196f3 !important;
  }
  .top-5 {
    top: 5px;
  }
  .start-5 {
    left: 5px;
  }
</style>
